import { FC, useMemo } from 'react';

// ========================= 组件 =========================

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================
import classname from 'classnames';

// ========================= 样式 =========================
import styles from './index.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface TitleProps {
    /**
     * @description: 标题
     * @return {*}
     */
    title?: string;
    /**
     * @description: 提示
     * @return {*}
     */
    tips?: string;
    /**
     * @description: 下边距
     * @return {*}
     */
    paddingBottom?: number;
}
/**
 * @description: 大会专区-模块标题
 * @param {*} param1
 * @return {*}
 */
const Title: FC<TitleProps> = ({ title, tips, paddingBottom }) => {

    const style = useMemo(() => {
        if (!paddingBottom) return {};
        return {
            paddingBottom: `${paddingBottom}px`
        }
    }, [paddingBottom]);

    return (
        <div
            className={
                classname(styles.TitleContainer, {
                    [styles.TitleContainerWithTips]: Boolean(tips),
                })
            }
        >
            {title && <h2 style={style}>{title}</h2>}
            {tips && <span>{tips}</span>}
        </div>
    );
}
export default Title;